const staff        = require ('./staff/staff')
const warehouseApp = require ('./warehouse/warehouse-app')
const clientApp = require ('./client/client')

export function start(settingsData){ 
	
	console.log('applications>', settingsData)

	if(settingsData.typeApp === 'client'){
		clientApp.start(settingsData);
		return
	}

	if(settingsData.device.deviceType === 'desktop'){
		settingsData.typeApp = 'staff';
		staff.start(settingsData);
	}
	
	if(settingsData.device.deviceType === 'tv'){
		settingsData.typeApp = 'staff';
		staff.start(settingsData)
	}
	
	if(settingsData.device.deviceType === "smartphone"){
		settingsData.typeApp = 'warehouse';
		warehouseApp.start(settingsData)
	}

}